import React from 'react';
import PropTypes from 'prop-types';
import Uploader from 'Components/Files/MessageAttachments/Uploader';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import Button from 'Components/UI/Button';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import fr from 'facet-rest';
import LinearProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/LinearProgress';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core';
import { Folder } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/Delete';

const DocumentUploader = withStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 2),
  },
  uploadContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  listContainer: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  progressBar: {
    minHeight: 32,
    margin: theme.spacing(2, 0),
    width: '100%',
  },
}))(({
  classes, onSuccess, attachments, relationship, onDelete,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleDelete = async attachment => {
    try {
      setIsLoading(true);
      await attachment.delete();
      attachments.resources().removeItem(attachment.id());
      setIsLoading(false);
    } catch {
      setIsLoading(false);
    } finally {
      onDelete();
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.uploadContainer}>
        <Typography variant="h3" component="p" color="primary">
          {'Attached Documents'}
        </Typography>
        <Uploader
          url={relationship.link('related').url()}
          onStart={() => setIsLoading(true)}
          onSuccess={onSuccess}
          onFinally={() => setIsLoading(false)}
          onCatch={err => {
            setIsLoading(false);
            displayErrorMessage(err, err.errors);
          }}
          successToastMessage=""
          disableClick={isLoading}
        >
          <Button
            startIcon={<AttachFileIcon />}
            variant="contained"
            color="primary"
            test="3120-upload-button"
            size="small"
          >
            {'Upload 3210 Letter'}
          </Button>
        </Uploader>
        <div className={classes.progressBar}>
          {isLoading && <LinearProgress visible={isLoading} />}
        </div>
      </div>
      <div className={classes.listContainer}>
        {attachments.resources().length() > 0 ? (
          <List dense>
            {attachments
              .resources()
              .list()
              .map(a => (
                <ListItem>
                  <ListItem style={{ cursor: 'pointer' }} onClick={() => window.open(a.relationship(fr.relationships.download.name).link('related').url(), '_blank')}>
                    <ListItemAvatar>
                      <Avatar>
                        <Folder />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={a.attr('name')} />
                  </ListItem>
                  <ListItemSecondaryAction>
                    <IconButton
                      test="delete-document"
                      edge="end"
                      aria-label="delete"
                      color="primary"
                      onClick={() => handleDelete(a)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
          </List>
        ) : (
          <div>
            <Typography
              align="center"
              variant="h3"
              component="p"
              color="primary"
            >
              {'Please Attach a 3210 letter'}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
});

DocumentUploader.defaultProps = {};

DocumentUploader.propTypes = {
  classes: PropTypes.object.isRequired,
  onSuccess: PropTypes.func.isRequired,
  attachments: PropTypes.array.isRequired,
  relationship: PropTypes.object.isRequired,
};

export default DocumentUploader;
